import React from 'react';
import Slider from 'react-slick';
import classes from './banner.module.scss';

const mockSteps = [
  {
    id: 1,
    name: 'Організація дня народження',
    image:
      'https://www.thoughtco.com/thmb/UBGsDSh_ndv19uqUIzhGbVd4eYs=/768x0/filters:no_upscale():max_bytes(150000):strip_icc()/birthday-cake-with-candles-and-sparklers--529391959-5c25a2cb46e0fb0001c3dc44.jpg?auto=format&fit=crop&w=400&h=250&q=60'
  },
  {
    id: 2,
    name: 'Виготовлення шоколадних цукерок',
    image:
      'https://radioimg.s3.amazonaws.com/kykyfm/styles/delta__775x515/s3/dreamstime_s_67066916.jpg?auto=format&fit=crop&w=400&h=250&q=60'
  },
  {
    id: 3,
    name: 'Ідеальне святкування',
    image:
      'https://italianallegria.com/wp-content/uploads/2018/09/celeb_port1.png?auto=format&fit=crop&w=400&h=250&q=60'
  },
  {
    id: 4,
    name: 'Майстеркласи',
    image:
      'https://i0.wp.com/www.adventuresportsnetwork.com/wp-content/uploads/2018/01/otto-norin-430454.jpg?w=1700&ssl=1'
  },
  {
    id: 5,
    name: 'Духмяна випічка',
    image:
      'https://static.toiimg.com/photo/msid-28743376,width-96,height-65.cms?auto=format&fit=crop&w=400&h=250&q=60'
  }
];

const settings = {
  infinite: true,
  autoplay: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true
};

const Banner = () => {
  return (
    <div className={classes.banner}>
      <Slider {...settings}>
        {mockSteps.map((step: any) => (
          <div key={step.id} className={classes.step}>
            <h3>{step.name}</h3>
            <img src={step.image} alt={step.label} />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Banner;
